import { memo, useCallback } from 'react';
import { isClipAudiogram } from '@goldcast/player-config/src/utils/clipUtils';
import PlayerMenuTooltip from '../PlayerMenus/PlayerMenuTooltip';
import { SelectionOutlineAction } from '../Outlines/types';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { toggleSpeakerLabels } from '@/stores/clip';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';
import Icon from '@/components/atoms/Icon';

function SpeakerLabelRemoveButton() {
  const { clipId, clipData } = useClipsContext();

  const isAudiogram = isClipAudiogram(clipData);
  const useAnimatedSpeakerCards = !isAudiogram;

  const removeSpeakerLabel = useCallback(() => {
    toggleSpeakerLabels(clipId, false);
    EventBus.dispatch(CustomEvents.SelectionOutlineAction, {
      action: SelectionOutlineAction.DESELECT
    });
  }, [clipId]);

  return (
    <button
      onClick={removeSpeakerLabel}
      data-testid="speaker-label-remove-button"
      className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
    >
      {useAnimatedSpeakerCards ? <Icon name="IconEyeOff" size={20} /> : <Icon name="IconTrash" size={20} />}
      <PlayerMenuTooltip content={useAnimatedSpeakerCards ? 'Hide' : 'Remove'} />
    </button>
  );
}

export default memo(SpeakerLabelRemoveButton);
